<div class="exception-body notfound">
    <div class="exception-panel">
        <div class="exception-image">
            <img src="assets/layout/images/exception/icon-404.png">
        </div>

        <div class="exception-detail">
            <h1>PÁGINA NO ENCONTRADA</h1>
            <p>El recurso solicitado no esta disponible.</p>
            <p-button label="IR AL INICIO" [routerLink]="['/']"></p-button>
        </div>
    </div>
</div>
